import { render, staticRenderFns } from "./enchancedSecurity.vue?vue&type=template&id=5b6084ec"
import script from "./enchancedSecurity.vue?vue&type=script&lang=js"
export * from "./enchancedSecurity.vue?vue&type=script&lang=js"
import style0 from "./enchancedSecurity.vue?vue&type=style&index=0&id=5b6084ec&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6084ec')) {
      api.createRecord('5b6084ec', component.options)
    } else {
      api.reload('5b6084ec', component.options)
    }
    module.hot.accept("./enchancedSecurity.vue?vue&type=template&id=5b6084ec", function () {
      api.rerender('5b6084ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/enchancedSecurity.vue"
export default component.exports